import {defineMessages} from 'react-intl';

const messages = defineMessages({
  ssoLogin: {
    id: 'ssoLogin',
    defaultMessage: 'Company account'
  },
  emailAndPasswordLogin: {
    id: 'emailAndPasswordLogin',
    defaultMessage: 'Email'
  },
  phoneNumber: {
    id: 'common.forms.phoneNumber',
    defaultMessage: 'Phone Number'
  },
  domainPasswordLogin: {
    id: 'domainPasswordLogin',
    defaultMessage: 'Workspace password'
  },
  formAction_iHaveAnAdminAccount: {
    id: 'formAction_iHaveAnAdminAccount',
    defaultMessage: 'I have an admin account'
  },
  formAction_iHaveAnActivationCode: {
    id: 'formAction_iHaveAnActivationCode',
    defaultMessage: 'I have an activation code'
  },
  loginWithProvider: {
    id: 'LoginWithProvider',
    defaultMessage: 'Log in with {provider}'
  }
});

export default messages;
